import * as storeAnalysis from '../services/storeAnalysis';

export default {
  namespace: 'storeAnalysis',
  state: {
    referMessage: {},
    downLoadList: {},
    storeTypeList: [],
  },
  effects: {
    *getReferMessage({ payload: { values } }, { call, put }) {
      const response = yield call(storeAnalysis.getReferMessage, { ...values });
      console.log('response', response);
      yield put({
        type: 'save',
        payload: {
          referMessage: response?.data,
        },
      });
    },
    *getDownLoadList({ payload: { values } }, { call, put }) {
      const response = yield call(storeAnalysis.getDownLoadList, { ...values });
      yield put({
        type: 'save',
        payload: {
          downLoadList: response?.data,
        },
      });
    },
    // 获取门店树形列表
    *getStoreTreeList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(storeAnalysis.getStoreTreeList, values);
      yield put({
        type: 'save',
        payload: {
          storeTreeList: response.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getStoreType({ payload: { values } }, { call, put }) {
      const response = yield call(storeAnalysis.getStoreType, values);
      yield put({
        type: 'save',
        payload: {
          storeTypeList: response.data,
        },
      });
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {},
};
